import { render } from "./LogHistoryList.vue?vue&type=template&id=66d6463e"
import script from "./LogHistoryList.vue?vue&type=script&lang=js"
export * from "./LogHistoryList.vue?vue&type=script&lang=js"
script.render = render

export default script